export default __webpack_public_path__ + "static/media/DAIF_UseCase_Loop.dada6929.mp4";